const state = {
  commissionInfo: "",
  // Ułamek (np. 0.15) pobierany z API z parametru COMMISSION - brak wartości do czasu pobrania.
  default_commission: null,
  user_commission_message: "",
};

const mutations = {
  SET_COMMISSION(state, payload) {
    state.commissionInfo = payload.message;
    if (payload.value) state.default_commission = payload.value;
    setTimeout(() => (state.commissionInfo = ""), 3000);
  },
  GET_CURRENT_COMMISSION(state, payload) {
    state.default_commission = payload;
  },
  SET_USER_COMMISSION(state, payload) {
    state.user_commission_message = payload;
    setTimeout(() => (state.user_commission_message = ""), 3000);
  },
};

const getters = {
  getCommissionInfo: (state) => {
    return state.commissionInfo;
  },
  getCurrentCommission: (state) => {
    if (state.default_commission === null) {
      return null;
    }
    return Math.round(state.default_commission * 100 * 100) / 100;
  },
  getUserCommissionMessage: (state) => {
    return state.user_commission_message;
  },
};

export default {
  state,
  mutations,
  getters,
};
